import React from "react";
import styled from "styled-components";

const Yellow = styled.span`
  background-color: #ff0;
  font-weight: bold;
  color: black;
`;

interface HighlightProps {
  readonly searchText: string | null;
  readonly children: string | null;
}

const Highlight: React.FC<HighlightProps> = ({ searchText, children }) => {
  if (!children || !searchText?.trim()) return <>{children}</>;

  const words = searchText
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map(word => word.replace(/[-[\]/{}()**?.\\^$|]/g, "\\$&"));

  if (words.length === 0) return <>{children}</>;

  const regex = new RegExp(`(${words.join("|")})`, "gi");
  const parts = children.split(regex);

  return (
    <>
      {parts.map((part, index) =>
        regex.test(part) ? <Yellow key={`${index}_${part}`}>{part}</Yellow> : part
      )}
    </>
  );
};

export default Highlight;
